import { defineMessages } from "react-intl";

import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

import CommonFieldName from "./CommonFieldName";
import DateTimeField from "./impl/DateTimeField";
import FieldModel from "./impl/FieldModel";
import { createField } from "./impl/fieldModelUtil";
import NameField from "./impl/NameField";
import UserField from "./impl/UserField";

export enum ResourceFieldName {
  NAME = CommonFieldName.NAME,
  URL = "url",
  OWNER = CommonFieldName.USER,
  OWNER_NAME = "user.fullName",
  SHARED_WITH = "userIds",
  CREATED_AT = CommonFieldName.CREATED_AT,
  UPDATED_AT = CommonFieldName.UPDATED_AT,
  TYPE = "file.contentType",
  SIZE = "file.contentLength",
  FOLDER = "folder.id",
  EXTENSION = "extension",
  TRASHED_AT = "trashedAt",
}

const displayNames = defineMessages<ResourceFieldName>({
  [ResourceFieldName.CREATED_AT]: {
    id: "resource.field.createdAt",
    defaultMessage: "Date Created",
    description: "Created At field of resource",
  },
  [ResourceFieldName.EXTENSION]: {
    id: "resource.field.extension",
    defaultMessage: "Extension",
    description: "Extension field of resource",
  },
  [ResourceFieldName.FOLDER]: {
    id: "resource.field.folder",
    defaultMessage: "Folder",
    description: "Folder field of resource",
  },
  [ResourceFieldName.NAME]: {
    id: "resource.field.name",
    defaultMessage: "File Name",
    description: "Name field of resource",
  },
  [ResourceFieldName.OWNER]: {
    id: "resource.field.owner",
    defaultMessage: "Owner",
    description: "Owner field of resource",
  },
  [ResourceFieldName.OWNER_NAME]: {
    id: "resource.field.ownerName",
    defaultMessage: "Owner Name",
    description: "Owner name field of resource",
  },
  [ResourceFieldName.SHARED_WITH]: {
    id: "resource.field.sharedWith",
    defaultMessage: "Shared With",
    description: "Shared With users field of resource",
  },
  [ResourceFieldName.SIZE]: {
    id: "resource.field.size",
    defaultMessage: "File Size",
    description: "File size field of resource",
  },
  [ResourceFieldName.TRASHED_AT]: {
    id: "resource.field.trashedAt",
    defaultMessage: "Trashed At",
    description: "Trashed At field of resource",
  },
  [ResourceFieldName.TYPE]: {
    id: "resource.field.type",
    defaultMessage: "File Type",
    description: "File type field of resource",
  },
  [ResourceFieldName.UPDATED_AT]: {
    id: "resource.field.updatedAt",
    defaultMessage: "Date Modified",
    description: "Updated At field of resource",
  },
  [ResourceFieldName.URL]: {
    id: "resource.field.url",
    defaultMessage: "URL",
    description: "URL field of resource",
  },
});

const resourceFieldModel = new FieldModel(
  [
    new NameField({
      displayName: displayNames[ResourceFieldName.NAME],
      name: ResourceFieldName.NAME,
    }),
    new UserField({
      displayName: displayNames[ResourceFieldName.OWNER],
      name: ResourceFieldName.OWNER,
      platformFilterNames: ["userId", "user.id"],
    }),
    new UserField({
      displayName: displayNames[ResourceFieldName.OWNER_NAME],
      name: ResourceFieldName.OWNER_NAME,
    }),
    new DateTimeField({
      displayName: displayNames[ResourceFieldName.CREATED_AT],
      name: ResourceFieldName.CREATED_AT,
    }),
    new DateTimeField({
      displayName: displayNames[ResourceFieldName.TRASHED_AT],
      name: ResourceFieldName.TRASHED_AT,
    }),
    new DateTimeField({
      displayName: displayNames[ResourceFieldName.UPDATED_AT],
      name: ResourceFieldName.UPDATED_AT,
    }),
    {
      displayName: displayNames[ResourceFieldName.SIZE],
      name: ResourceFieldName.SIZE,
      platformFilterNames: ["file.contentLength"],
      type: FieldType.NUMBER,
    },
    {
      displayName: displayNames[ResourceFieldName.TYPE],
      name: ResourceFieldName.TYPE,
      type: FieldType.STRING,
    },
    {
      displayName: displayNames[ResourceFieldName.EXTENSION],
      name: ResourceFieldName.EXTENSION,
      sortName: "extension,file.contentType",
      type: FieldType.STRING,
    },
    {
      displayName: displayNames[ResourceFieldName.URL],
      name: ResourceFieldName.URL,
      type: FieldType.STRING,
    },
    {
      displayName: displayNames[ResourceFieldName.SHARED_WITH],
      name: ResourceFieldName.SHARED_WITH,
      type: FieldType.OBJECT,
    },
    {
      displayName: displayNames[ResourceFieldName.FOLDER],
      name: ResourceFieldName.FOLDER,
      platformFilterNames: ["folderId"],
      type: FieldType.OBJECT,
    },
  ].map(createField)
);

export default resourceFieldModel;
